import { render } from "./YesNo.vue?vue&type=template&id=812cad92&ts=true"
import script from "./YesNo.vue?vue&type=script&lang=ts"
export * from "./YesNo.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__